import React from 'react';
import { motion } from 'framer-motion';

/**
 * Sanfter Page-Transition-Wrapper.
 * Wird in <AnimatePresence mode="wait"> eingebettet, damit die alte Seite
 * vollständig ausfadet, bevor die neue erscheint.
 */
const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
